import React from 'react';
import { useLocation } from 'react-router-dom';
import { SeoHead } from '../components/SeoHead';
import { JsonLd } from '../components/JsonLd';
import { getSeoForPath } from '../config/seoPages';
import {
  buildOrganizationSchema,
  buildWebSiteSchema,
  buildBreadcrumbSchema,
  buildFaqSchema,
  buildProductOfferSchema,
  FaqItem,
} from '../utils/structuredData';
import { useLocale } from '../hooks/useLocale';

interface PublicPageSeoProps {
  breadcrumbs?: { name: string; path: string }[];
  faqs?: FaqItem[];
  productPlans?: { name: string; price: string; description: string }[];
  includeSiteSchemas?: boolean;
}

export const PublicPageSeo: React.FC<PublicPageSeoProps> = ({
  breadcrumbs,
  faqs,
  productPlans,
  includeSiteSchemas = false,
}) => {
  const { pathname } = useLocation();
  const locale = useLocale();
  const meta = getSeoForPath(pathname);
  const schemas: Record<string, unknown>[] = [];

  if (includeSiteSchemas) {
    schemas.push(buildOrganizationSchema(locale));
    schemas.push(buildWebSiteSchema(locale));
  }
  if (breadcrumbs && breadcrumbs.length > 0) {
    schemas.push(buildBreadcrumbSchema(breadcrumbs, locale));
  }
  if (faqs && faqs.length > 0) {
    schemas.push(buildFaqSchema(faqs));
  }
  if (productPlans && productPlans.length > 0) {
    schemas.push(...buildProductOfferSchema(productPlans, locale));
  }

  return (
    <>
      <SeoHead meta={meta} />
      {schemas.length > 0 && <JsonLd data={schemas.length === 1 ? schemas[0] : schemas} />}
    </>
  );
};
